import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "firebase/compat/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB0Fo26uxRO-8m8_TiGAZD8-uFdywJBZfU",
  authDomain: "ministudymate.firebaseapp.com",
  projectId: "ministudymate",
  storageBucket: "ministudymate.appspot.com",
  messagingSenderId: "491788208340",
  appId: "1:491788208340:web:622c79cfe842c3dad81341",
  measurementId: "G-SN657P4HJP",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Export the Firebase Storage instance
export const storage = firebase.storage();
export const auth = firebase.auth();
